import React from 'react'

export default function WithDefaultIconProps (SVGContent) {
  class WithDefaultIconProps extends React.Component {
    render () {
      return (
        <SVGContent
          height={24}
          width={24}
          fill='gray'
          viewBox='0 0 16 16'
          version='1.1'
          ariaHidden='true'
          {...this.props}
        />
      )
    }
  }
  return WithDefaultIconProps
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/icons/WithDefaultIconProps.js